export const eMoneyHowItWorks: React.FC = () => {
  return (
    <div>
      <ul>
        <li>Sync your contacts between eMoney and Zocks</li>
        <li>Create new eMoney contacts from your meetings, emails or documents</li>
        <li>Fill and update eMoney Basic and Advanced Facts with insights from your meetings, emails or documents</li>
        <li>Prepare for meetings using combined data from Zocks, eMoney, and your connected systems.</li>
        <li>Get instant insights from eMoney with the Ask Anything AI Assistant</li>
        <li>Generate email replies based on eMoney information</li>
        <li>Fill Zocks Forms utilizing financial planning data from eMoney</li>
      </ul>
    </div>
  )
}
